import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from './Button';
import { UserCheck, ShieldCheck, Handshake } from 'lucide-react';
const benefits = [{
  icon: UserCheck,
  text: 'More qualified leads who are ready to buy'
}, {
  icon: ShieldCheck,
  text: 'More confident buyers who trust your dealership'
}, {
  icon: Handshake,
  text: 'Stronger trust built before they even step on the lot'
}];
export function MarketingJourneySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const scrollToForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-82">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-83">
        <div className="max-w-4xl mx-auto text-center" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-85">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 font-playfair leading-tight text-[#0A1628]" data-id="element-86">
              Marketing That Matches How People{' '}
              <span className="text-[#D4AF37]" data-id="element-87">Actually Buy Boats</span>
            </h2>

            <div className="space-y-6 text-gray-600 text-lg mb-12 max-w-3xl mx-auto" data-id="element-88">
              <p data-id="element-89">
                Boat buyers don't convert in one click. They research, compare,
                revisit, and convert when they are ready.
              </p>
              <p data-id="element-90">
                DealersChoice marketing follows that exact journey. We ensure
                your dealership appears across every stage of their research,
                comparison, and decision-making process.
              </p>
            </div>
          </motion.div>

          <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-91">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            y: 0,
            scale: 1
          } : {
            opacity: 0,
            y: 30,
            scale: 0.95
          }} transition={{
            delay: i * 0.15,
            duration: 0.5,
            ease: 'easeOut'
          }} className="relative bg-[#0A1628] rounded-xl p-6 text-center group" data-id="element-92">
                <motion.div initial={{
              scale: 0
            }} animate={isInView ? {
              scale: 1
            } : {
              scale: 0
            }} transition={{
              delay: i * 0.15 + 0.3,
              duration: 0.4,
              type: 'spring',
              stiffness: 200
            }} className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-93">
                  <benefit.icon className="w-6 h-6 text-white" data-id="element-94" />
                </motion.div>
                <p className="text-white font-medium leading-snug text-sm" data-id="element-95">
                  {benefit.text}
                </p>
                <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#D4AF37]/40 transition-colors duration-300 pointer-events-none" data-id="element-96"></div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} data-id="element-97">
            <Button onClick={scrollToForm} className="bg-[#D4AF37] text-white hover:bg-[#b5952f] border-none text-lg px-8 py-4" data-id="element-98">
              Get A Free Strategy Call
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}